import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const FloppyIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 18)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="m16.5 15.3a1.2 1.2 0 0 1 -1.2 1.2h-12.6a1.2 1.2 0 0 1 -1.2-1.2v-10.3l3.5-3.5h10.3a1.2 1.2 0 0 1 1.2 1.2z" />
      <path d="m13 10.7h-8v5.8h8zm0-9.2h-6.9v4.6h7v-4.6z" />
    </SVG>
  );
};
